import { IconButton, Tooltip, Typography } from '@material-ui/core';
import { StyledTableCell } from './tableStyle';
import './tcardTemplate.scss';
import moment from 'moment';
import { AppStorage } from '../../../../../Core/Service/storage-service';
import TodayIcon from '@material-ui/icons/Today';

export default function HolidayRow(props) {
    const { tCardList, handleCalendarButtonClick, dt } = props;
    const portalSetting = AppStorage.getPortalSetting();

    return (
        <StyledTableCell align="center" width={`${Math.floor(100 / tCardList.closeDays.length)}%`} className="holiday-container">
            <div className="holiday-container-header">
                <Typography className="holiday-container-lable">Holidays </Typography>
                <Tooltip title="User Holiday" aria-label="UserHoliday">
                    <IconButton size="medium" className="holiday-container-icon-btn" onClick={() => handleCalendarButtonClick(dt)}>
                        <TodayIcon fontSize="small" className="holiday-container-icon" />
                    </IconButton>
                </Tooltip>
            </div>{' '}
            <div className={`holiday-container-list custom-scroll`}>
                {tCardList.usersHoliday
                    .filter((m) => moment(m.date).format('YYYY-MM-DD') === moment(dt).format('YYYY-MM-DD'))
                    .map((k) => (
                        <div
                            style={{
                                background: k.bg,
                                color: k.color,
                                borderBottom: `1px solid ${portalSetting.portalSettingsIsHolidayColor}`,
                                padding: 1
                            }}
                        >
                            <Typography
                                style={{
                                    color: portalSetting.portalSettingsIsHolidayColor
                                }}
                                className="holiday-container-list-name"
                            >
                                {k.name}
                            </Typography>
                        </div>
                    ))}
            </div>
        </StyledTableCell>
    );
}
